import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/_org/transactions/$id")({
  component: RouteComponent,
});

// This exists for backwards compatibility so that old links are not broken
function RouteComponent() {
  const navigate = Route.useNavigate();
  const { id } = Route.useParams();
  return navigate({
    params: {
      id,
    },
    to: "/transactions/card/$id",
  });
}
